// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OXFO","colBig":"styles_colBig__AAXBO","colSmall":"styles_colSmall__2j_o1","shopifyNameWrapper":"styles_shopifyNameWrapper__2uDN2"};